import React from "react";
import { withRouter } from "react-router-dom";
import TotalOfficeStockBuild from "../../widgets/office/dashboard/TotalOfficeStockBuild";
import CurrentVacancy from "../../widgets/office/dashboard/CurrentVacancy";
import CurrentPassingRent from "../../widgets/office/region/CurrentPassingRent";
import UpcomingSupply from "../../widgets/office/dashboard/UpcomingSupply";
import OfficeDemandSupplyChart from "../../widgets/office/region/OfficeDemandSupplyChart";
import NewCompletionTable from "../../widgets/office/region/NewCompletionTable";
import OfficeStock from "../../widgets/office/region/OfficeStock";
import OfficeAbsorptionTrendChart from "../../widgets/office/region/OfficeAbsorptionTrendChart";
import SummaryTable from "../../widgets/office/region/SummaryTable";
import ProjectsTableRegion from "../../widgets/office/region/ProjectsTableRegion";
import FutureSupply from "../../widgets/office/region/FutureSupply";
import UpcomingProjectCompletionsRegion from "../../widgets/office/region/UpcomingProjectCompletionsRegion";
import YearWiseAnalysis from "../../widgets/office/region/YearWiseAnalysis";
import TopTenProjects from "../../widgets/office/region/TopTenProjects";
import MajorRecentLeaseTransactionsRegion from "../../widgets/office/region/MajorRecentLeaseTransactionsRegion";
import TopOfficeTenantsRegion from "../../widgets/office/region/TopOfficeTenantsRegion";
import RegionMap from "../../widgets/office/region/RegionMap";
import RentByCities from "../../widgets/office/region/RentByCities";
import StockDemandSupplyVacancy from "../../widgets/office/dashboard/StockDemandSupplyVacancy";
import { apiMiddleware } from "../../services/apis/apiMiddleware";
import RentalAnalysisChart from "../../widgets/office/region/RentalAnalysisChart";
import OfficeSupplyChart from "../../widgets/office/region/OfficeSupplyChart";
import MarketRent from "../../widgets/office/dashboard/MarketRent";
import CommercialTrends from "../../widgets/office/region/CommercialTrends";
import RentalTrends from "../../widgets/office/region/RentalTrends";
import BusinessTrends from "../../widgets/office/region/BusinessTrends";
// import OfficeDemandSupplyChart from "../../widgets/office/dashboard/OfficeDemandSupplyChart";
// import RentalsAnalysisChart from "../../widgets/office/dashboard/RentalsAnalysisChart";
class Region1 extends React.Component {
  componentDidMount() {
    let body = new FormData();
    body.append("path", window.location.pathname);
    body.append("action", "visited");
    if (window.location.search.includes("?")) {
      body.append("hash", window.location.search.split("?").pop());
    } else {
      body.append("hash", "");
    }

    apiMiddleware
      .post(process.env.REACT_APP_USER_ACTIVITY, body)
      .then((res) => {
        console.log(res);
      });
  }
  render() {
    return (
      <div className="container-fluid region">
        <div className="row">
          <div className="col-lg-12">
            <div className="newDashboard newDashboard5row">
              <div class="newDashboardInner">
                <TotalOfficeStockBuild />
              </div>
              <div class="newDashboardInner">
                <CurrentVacancy />
              </div>
              <div class="newDashboardInner">
                <CurrentPassingRent />
              </div>
              <div class="newDashboardInner">
                <MarketRent />
              </div>
              <div class="newDashboardInner">
                <UpcomingSupply />
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-lg-12 mb-3">
                <OfficeDemandSupplyChart />
              </div>
              <div className="col-lg-12">
                <RentalAnalysisChart />
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-12">
            <OfficeSupplyChart />
          </div>
          <div className="col-lg-12 mt-4">{/* <CommercialTrends /> */}</div>
          <div className="col-lg-12 mt-4">
            <RentalTrends />
          </div>
          <div className="col-lg-12 mt-4">
            <BusinessTrends />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <OfficeStock />
          </div>
          <div className="col-lg-5">
            <ProjectsTableRegion />
          </div>
          <div className="col-lg-3">
            <SummaryTable />
          </div>
          <div className="col-lg-9 mapContainer customPage mb-4 mt-4">
            <RegionMap />
          </div>
          <div className="col-lg-3 rightSideBar">
            <NewCompletionTable />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <OfficeAbsorptionTrendChart />
          </div>
          <div className="col-lg-4">
            <FutureSupply />
          </div>
          <div className="col-lg-4">
            <UpcomingProjectCompletionsRegion />
          </div>
          <div className="col-lg-12 mt-4">
            <YearWiseAnalysis />
          </div>
          <div className="col-lg-12 mt-4">
            <TopTenProjects />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-lg-8">
            <MajorRecentLeaseTransactionsRegion />
          </div>
          <div className="col-lg-4">
            <TopOfficeTenantsRegion />
          </div>
          <div className="col-lg-12 mt-4">
            <RentByCities />
          </div>
          <div className="col-lg-12 mt-4">
            <StockDemandSupplyVacancy />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Region1);
